import InvalidParametersException from '../exceptions/InvalidParametersException';
import { formatNumberWithLeadingZero } from '../utils/numbers';
export function isDateValid(date) {
    return !Number.isNaN(date.getTime());
}
export function convertDateStringToDate(dateTimeString) {
    const date = new Date(dateTimeString);
    if (!isDateValid(date)) {
        throw new Error(`${dateTimeString} is not a valid date string. Date could not be created.`);
    }
    return date;
}
export function getLocale(defaultLocale = 'nl') {
    return document.documentElement.lang || navigator.language || defaultLocale;
}
export function isBefore(dateOne, dateTwo) {
    const dateOneUTC = Date.UTC(dateOne.getFullYear(), dateOne.getMonth(), dateOne.getDate());
    const dateTwoUTC = Date.UTC(dateTwo.getFullYear(), dateTwo.getMonth(), dateTwo.getDate());
    return dateOneUTC < dateTwoUTC;
}
export function isSameDate(dateOne, dateTwo) {
    return (dateOne.getFullYear() === dateTwo.getFullYear() &&
        dateOne.getMonth() === dateTwo.getMonth() &&
        dateOne.getDate() === dateTwo.getDate());
}
export function getFullMonthName(month, locale = 'default') {
    return month.toLocaleString(locale, { month: 'long', year: 'numeric' });
}
export function getDatesOfMonth(month, year) {
    const lastDayOfTheMonth = new Date(year, month + 1, 0).getDate();
    return [...new Array(lastDayOfTheMonth).keys()].map((day) => day + 1);
}
export function getDayOfWeekNumber(dateOrDay, monthIndex, year) {
    const callback = (date) => (6 + date.getDay()) % 7;
    if (dateOrDay instanceof Date) {
        return callback(dateOrDay);
    }
    if (monthIndex !== undefined && year !== undefined) {
        const date = new Date(year, monthIndex, dateOrDay);
        return callback(date);
    }
    throw new InvalidParametersException({
        message: 'Please provide either a Date object or year, month, and day as numbers.'
    });
}
export function getMonday() {
    return new Date('01-01-2024');
}
export function formatToDateString(date) {
    const month = formatNumberWithLeadingZero(date.getMonth() + 1);
    const day = formatNumberWithLeadingZero(date.getDate());
    return `${date.getFullYear()}-${month}-${day}`;
}
